<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Category Store Group" subTitle="Forms" />

    <CreateCategoryStoreGroup />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateCategoryStoreGroup from "@/components/Pages/Master/CategoryStoreGroup/CreateCategoryStoreGroup.vue";

export default defineComponent({
  name: "CreateCategoryStorePage",
  components: {
    PageTitle,
    CreateCategoryStoreGroup,
  },
});
</script>
